import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {prepareAuthHeaders} from "../../utils/prepareAuthHeaders";

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: fetchBaseQuery({ baseUrl: '/User',
        prepareHeaders: prepareAuthHeaders }),
    keepUnusedDataFor: 1,
    endpoints: (builder) => ({
        getUserDetails: builder.query({
            query: () => ({
                url: `/UserDetails`,
                method: 'GET',
            }),
        }),
        test: builder.query({
            query: () => ({
                url: `/Test`,
                method: 'GET',
            }),
        }),
        getUsersFlags: builder.mutation({
            query: ({ data }) => ({
                url: `/GetUsersFlags`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Post'],
        }),
        saveUserFlag: builder.mutation({
            query: ({ data }) => ({
                url: `/SaveUserFlag`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Post'],
        }),
        notClosedStatementsDetails: builder.query({
            query: () => ({
                url: `/NotClosedStatementsDetails`,
                method: 'GET',
            }),
        }),
        enableHealthChecks: builder.mutation({
            query: () => ({
                url: `/EnableHealthChecks`,
                method: 'POST',
                invalidatesTags: ['Post'],
            }),
        }),
        listPerson: builder.query({
            query: () => ({
                url: `/ListPerson`,
                method: 'GET',
            }),
        }),
        createUserFlag: builder.mutation({
            query: ({ data }) => ({
                url: `/CreateUserFlag`,
                method: 'POST',
                body: data,
                invalidatesTags: ['Post'],
            }),
        }),
    }),
});

export const { 
    useGetUserDetailsQuery,
    useTestQuery,
    useGetUsersFlagsMutation,
    useSaveUserFlagMutation,
    useNotClosedStatementsDetailsQuery,
    useEnableHealthChecksMutation,
    useListPersonQuery,
    useCreateUserFlagMutation
} = userApi;
